import Viewer from '../components/preview/v-view/src/component'
import Polling from './polling'

const components = [
  Viewer
];

export default {
  install(Vue) {
    components.map(component => {
      Vue.component(component.name, component);
    });
    Vue.prototype.$polling = Polling;
  }
};
